import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  ABOUT_PATH,
  FORGOT_PASSWORD_PATH,
  REGISTER_PATH,
} from "../../constants";
import { FIREBASE_AUTH } from "../../FirebaseConfig";
import { signInWithEmailAndPassword } from "firebase/auth";
import { HOME_PATH, API_BASE_URL } from "../../constants";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";

const Feedback = () => {
  const [feedback, setFeedback] = useState("");
  const [user, setUser] = useState(null);
  const [feedbackList, setFeedbackList] = useState([]);

  useEffect(() => {
    onAuthStateChanged(FIREBASE_AUTH, (user) => {
      console.log("fresh");
      console.log(user);
      setUser(user);
    });
  });

  useEffect(() => {
    fetch(`${API_BASE_URL}/get_feedback`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Feedback:", data);
        setFeedbackList(data);
      })
      .catch((error) => console.error("Error fetching feedback:", error));
  }, []);

  const handleSubmit = async () => {
    if (!user) {
      console.error("User is not logged in.");
      return;
    }

    const feedbackData = {
      email: user.email,
      message: feedback,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/submit_feedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(feedbackData),
      });

      const result = await response.json();

      if (response.ok) {
        window.alert("Thanks for your feedback!");
        window.location.reload();
        console.log("Feedback submitted successfully:", result);
        setFeedback("");
      } else {
        console.error("Error submitting feedback:", result.error);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          borderColor: "black",
          border: "2px solid black",
          borderRadius: 10,
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            width: 500,
            height: 250,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h1 style={{ fontSize: 40 }}>SUBMIT FEEDBACK</h1>
          <textarea
            placeholder="Type feedback to be addressed ..."
            style={{
              backgroundColor: "white",
              height: 60,
              width: "55%",
              margin: 20,
              border: "2px solid black",
              borderRadius: 10,
              paddingLeft: 10,
            }}
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
          ></textarea>
          {user && (
            <button
              onClick={handleSubmit}
              style={{
                border: "2px solid black",
                borderRadius: 10,
                padding: "10px 20px",
                cursor: "pointer",
              }}
            >Submit</button>
          )}
        </div>
        <div
          style={{
            backgroundColor: "white",
            width: 700,
            height: 400,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Feedback;
